module.exports = __webpack_public_path__ + "img/new_05_workshop_2.a6aeb7c2.jpg";